// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 379) return "static/chunks/379-598d0cb03c532bd2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"60":"23c6b7aa10b0ccbf","167":"9b214ad994daba2d","377":"e08e1a6518ac1c22","407":"59a35d2b5fd921d2","548":"51e3fa2b88f81953","743":"505085efc3b68d4b","782":"be8561a817ca25d2"}[chunkId] + ".js";
};